import React, { Component } from 'react';
import { getDomElements } from '~/services/domService';
import Switcher from '@/Switcher'
import { observer, inject } from 'mobx-react';

@inject("featuresListStore") @observer 
export class HighlightLinks extends Component {
  constructor(props = { featureId }){
    super(props);
    this.state = {
      className: 'billy-dom__link_highlight',
    }
  }
  onToggle(isToggleOn){
    const $links = getDomElements(/A$/g);
    for (let $link of $links) {
      if (isToggleOn) {
        $link.classList.add(this.state.className)
      } else {
        $link.classList.remove(this.state.className)
      }
    }
  }
  render() {
    let { featureId } = this.props;
    let { setFeatureOptions, getFeatureById } = this.props.featuresListStore;
    let feature = getFeatureById(featureId);
    let { isToggleOn } = feature.options;
    this.onToggle(isToggleOn);

    return (
      <Switcher changeHandler={ () => setFeatureOptions(featureId, {isToggleOn: !isToggleOn}) } isToggleOn={ isToggleOn } />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Feature/FeatureActions/HighlightLinks/index.js